<template>
  <option-panel :active="currency.active" @click="$emit('click', currency)">
    <div slot="icon" :class="$style.icon">{{ currency.sign }}</div>
    <div slot="title">{{ $t(currency.name) }}</div>
    <div slot="description">{{ currency.description }}</div>
  </option-panel>
</template>

<script>
import OptionPanel from 'molecules/panels/OptionPanel';

export default {
  name: 'CurrencyPanel',
  components: {
    OptionPanel,
  },
  props: {
    currency: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .icon
    +currency-icon
</style>
